import { DateTime } from 'luxon'

/** @param locale the UI language (`i18n.language`), so that month names match the rest of the text */
export function renderTimestamp(maybeTimestamp: string | undefined, locale: string) {
  return maybeTimestamp ? DateTime.fromISO(maybeTimestamp, { locale }).toFormat('DD, HH:mm') : '-'
}

/**
 * A server timestamp relative to the current time. Clamped to be just in the past, otherwise a browser clock running
 * slightly behind the server could show a change from a moment ago to be in the future.
 *
 * @param locale the UI language (`i18n.language`)
 */
export function renderRelativePastTimestamp(timestamp: string, locale: string) {
  const now = DateTime.now()
  const dateTime = DateTime.min(DateTime.fromISO(timestamp), now.minus({ milliseconds: 1 }))
  return dateTime.toRelative({ base: now, locale }) ?? renderTimestamp(timestamp, locale)
}
